import { Container } from '@chakra-ui/react';
import { ProductFeatures } from '@client/graphql/__generated__/types';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { CONTAINER_PADDINGS } from '../../components/Layouts/Container';
import { MOBILE_HEADER_HEIGHT } from '../../components/Layouts/MobileHeader';
import { OfferScorecardsForAgent } from '../../components/OfferScorecard/OfferScorecardsForAgent';
import { NotSupportedMarket } from '../../components/ProductFeatures/NotSupportedMarket';

export const OfferScorecardsPage = () => {
  const {
    loadingOrganizations,
    loadingIsSelectedOrgAdmin,
    isFeatureSupported,
  } = useAppContext();

  if (loadingOrganizations || loadingIsSelectedOrgAdmin) {
    return <CenterSpinner />;
  }

  if (!isFeatureSupported(ProductFeatures.OFFER_SCORECARD)) {
    return <NotSupportedMarket />;
  }

  return (
    <Container
      height={{ base: `calc(100vh - ${MOBILE_HEADER_HEIGHT})`, md: '100vh' }}
      minWidth={{ base: '100%', md: '80%' }}
      {...CONTAINER_PADDINGS}
    >
      <OfferScorecardsForAgent />
    </Container>
  );
};
